import { fetchWithSessionToken } from '../components/shared/fetchWithSessionToken';
import { CHAT_API_BASE } from '../config/api';

const DYNAMIC_ORDER_URL = `${CHAT_API_BASE}/companies/orders/dynamic`;

/**
 * Look up an order by identifier + customer info.
 *
 * Sends the identifying fields (order number, email/zip/phone) in the POST
 * body instead of the query string, so they never land in server access logs,
 * browser history, or Referer headers. The backend exposes both a POST form
 * (preferred) and the legacy GET form (OrderController#getOrderByIdOrEmail).
 *
 * @param {{companyId: string, searchParam: string, additionalParam?: string}} ids
 * @param {{withSession?: boolean, headers?: object}} [opts]
 *   withSession routes through fetchWithSessionToken (adds the bearer token +
 *   401 reauth retry); otherwise a plain unauthenticated fetch is used — the
 *   endpoint is public for the initial lookup.
 * @returns {Promise<Response>} the raw fetch Response; the caller handles .ok/json.
 */
export function fetchDynamicOrder({ companyId, searchParam, additionalParam }, opts = {}) {
  const { withSession = false, headers = {} } = opts;
  const doFetch = withSession ? fetchWithSessionToken : fetch;
  return doFetch(DYNAMIC_ORDER_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...headers },
    body: JSON.stringify({
      companyId,
      searchParam,
      additionalParam: additionalParam || '',
    }),
  });
}
